module.exports = __webpack_public_path__ + "img/accountZh.e4b15938.jpg";